import { gql } from "@apollo/client";
import { TOPIC_ADDITIONAL_FIELDS_FRAGMENT } from "../fragments/TopicFragments";

const BOOK_ONE_ON_ONE_CLASS = gql`
  mutation BookOneOnOneClass(
    $lessonId: ID!
    $levelId: ID!
    $notes: String
    $tailorMade: Boolean!
    $chapterId: ID
    $topicId: ID
    $cityId: ID
  ) {
    bookOneOnOneClass(
      input: {
        lessonId: $lessonId
        levelId: $levelId
        notes: $notes
        tailorMade: $tailorMade
        chapterId: $chapterId
        topicId: $topicId
        cityId: $cityId
      }
    ) {
      appointment {
        bookedClass {
          id
          date
          time
          startTime
          endHour24hr
          classType
          classSize
          seatsRemaining
          category
          teacher {
            id
            avatar
            givenName
            familyName
          }
          topic {
            ...TopicAdditionalFields
          }
          city {
            id
            name
          }
          level {
            title
          }
          chapter {
            name
          }
          participants {
            id
            name
            avatar
          }
        }
        bookedAt
        status
      }
    }
  }
  ${TOPIC_ADDITIONAL_FIELDS_FRAGMENT}
`;

export default BOOK_ONE_ON_ONE_CLASS;
